<template>
    <div>
        <!-- <Modal
            v-model="pageIndex"
            @on-visible-change="pageModalCancel"
            :footer-hide="true"
            width="458"
            class="page-modal"
        >
            <img :src="$store.state.static_img_url + 'pic/model/vip-model-icon.png'" />
            <p class="p1">体验专属会员服务，查询数量不上限！</p>
            <p class="p2">成为VIP会员， 即可查看剩余查询结果</p>
            <div class="go-vip-btn" @click="go">立即成为VIP会员</div>
        </Modal> -->
        <Modal
          v-model="pageIndex"
          @on-visible-change="pageModalCancel"
          width="600"
          class="applyModel"
          :mask-closable = "false"
        >
          <div slot="header">
            <p>温馨提示</p>
          </div>
          <p class="one-desc">普通用户查询数量受限，开通动脉橙机构版，可查看完整内容</p>
          <div slot="footer">
              <button @click="go">申请试用</button>
          </div>
        </Modal>
    </div>
</template>

<script>
export default {
  props: ['pageModal'],
  data() {
    return {
      pageIndex: false,
    }
  },
  methods: {
    pageModalCancel() {
      this.$emit('pagecancel', this.pageIndex)
    },
    go() {
      this.$emit('pagecancel', false)
      // this.$router.push({name: 'BuyVip'})
      let link = this.$store.state.index_path + '/applyTry?info_src=34'
      window.open(link)
    }
  },
  watch: {
    pageModal(value) {
      this.pageIndex = value
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
// .page-modal
//   >>> .ivu-modal
//     top: 50%
//     margin-top: -140px
//   >>> .ivu-modal-content
//     border-radius: 0
//     height: 280px
//     background: url('~pic/model/vip-model.png') no-repeat
//     background-size: 100%
//     .ivu-modal-close
//       right: 8px
//       top: 8px
//       .ivu-icon-ios-close
//         color: #ddd
//         &:hover
//           color: #553204
//   >>> .ivu-modal-body
//     padding: 0
//     text-align: center
//     font-size: 0
//     img
//       width: 138px
//       height: 137px
//       margin-top: -62px
//     .p1
//       color: #553204
//       font-size: 24px
//       font-weight: bold
//       margin-top: 22px
//     .p2
//       color: #553204
//       font-size: 16px
//       margin-top: 12px
//     .go-vip-btn
//       inlineBlock()
//       width:150px
//       height:40px
//       background:rgba(255,234,197,1)
//       border-radius:20px
//       color: #553204
//       font-size:14px
//       text-align: center
//       line-height: 40px
//       margin-top: 40px
//       cursor: pointer;
.applyModel
  >>> .ivu-form-item-error-tip
    padding-top: 3px
    color: #FC3B3B
  >>> .ivu-modal-close
    top: 10px
    &:hover
      i
        color: #FA7A50
  >>> .ivu-modal
    .ivu-modal-content
      border-radius: 0
      background-clip: initial
      .ivu-modal-header
        position: relative
        padding: 18px 24px
        font-size: 0
        p
          font-size: 20px
          color: #3C444F
          font-weight: bold
          padding-left: 20px
          position: relative
          &:before
            content: ''
            position: absolute
            width: 5px
            height: 18px
            background: rgba(12, 91, 222, 1)
            background: linear-gradient(0deg, rgba(244,107,69,1), rgba(255,183,94,1))
            border-radius: 3px
            top: 1px
            left: 0
      .ivu-modal-body
        padding: 24px 24px 0
      .ivu-modal-footer
        border-top: 0
        padding: 20px 0 30px
        text-align: center
        p
          font-size: 12px
          color: rgba(153, 153, 153, 1)
          margin-top: 12px
        button
          background: rgba(250, 122, 80, 1)
          color: #fff
          width: 120px
          height: 36px;
          border: 0
          font-size: 14px
          border-radius: 2px
          cursor: pointer
          &:hover
            background: #FC9C7C
</style>
